import get from 'lodash.get';
import * as tracking from 'dibs-tracking';
import SV from 'server-vars';
import { defaultLocale } from 'dibs-intl/exports/constants';

function getProductTrackingData(item, index) {
    return {
        position: index + 1,
        category: get(item, 'node.browseUrl') || '',
        categoryCode: get(item, 'node.categoryCode') || '',
        ...get(item, 'node.ecommerceTrackingParams'),
        name: SV.get('locale') === defaultLocale ? get(item, 'node.title') : 'n/a',
    };
}

function fireEcommerceImpressions(itemEdges, list) {
    tracking.trackEcommerce({
        type: 'productImpression',
        products: itemEdges.map((itemEdge, index) => ({
            list,
            ...getProductTrackingData(itemEdge, index),
        })),
    });
}

function fireEcommerceClick(index, itemEdge, list) {
    tracking.trackEcommerce({
        type: 'productClick',
        products: [
            {
                ...getProductTrackingData(itemEdge, index),
            },
        ],
        actionField: { list, itemId: itemEdge?.node?.serviceId },
    });
}

/**
 * @see PdpRespSimilarItemsLanding.jsx
 */
const LANDING_ACTION = 'landing module clicked';
const LANDING_CATEGORY = 'landing module interaction';
const LANDING_LIST = 'pdp browse similar items';
const LANDING_LIST_SOLD = 'sold pdp browse similar items';

export function trackLandingItemImpressions(landingItems, isSoldPdp) {
    fireEcommerceImpressions(landingItems, isSoldPdp ? LANDING_LIST_SOLD : LANDING_LIST);
}

export function trackItemClick({ moduleType = '', actionValue = '' } = {}) {
    const label = `related items${moduleType && ' - ' + moduleType}`;
    const action = `${LANDING_ACTION}${actionValue && ' - ' + actionValue}`;
    tracking.trackEvent({
        label,
        action,
        category: LANDING_CATEGORY,
    });
}

export function trackEcommerceLandingItemClick({ index, landingItem, isSoldPdp }) {
    fireEcommerceClick(index, landingItem, isSoldPdp ? LANDING_LIST_SOLD : LANDING_LIST);
}

export function trackLandingViewAllClick() {
    tracking.trackEvent({
        label: 'related items view all',
        action: LANDING_ACTION,
        category: LANDING_CATEGORY,
    });
}

/**
 * @see PdpRespSimilarItemsGrid.jsx
 */
export const SIMILAR_ITEMS_LIST = 'pdp you may also like';
export const VISUALLY_SIMILAR_ITEMS_LIST = 'pdp visually similar';

export function trackSimilarItemImpressions(gridItems, location = SIMILAR_ITEMS_LIST) {
    const items = gridItems.map(item => ({ node: item }));
    fireEcommerceImpressions(items, location);
}

export function trackSimilarItemClick(index, gridItem, location = SIMILAR_ITEMS_LIST) {
    const item = { node: gridItem };
    fireEcommerceClick(index, item, location);
}

const COMPLETE_THE_LOOK_LIST = 'pdp complete the look';
export function trackComplementaryItemClick(index, gridItem) {
    fireEcommerceClick(index, gridItem, COMPLETE_THE_LOOK_LIST);
}

export function trackComplementaryItemImpressions(gridItems) {
    fireEcommerceImpressions(gridItems, COMPLETE_THE_LOOK_LIST);
}

export function trackComplementaryGridViewEvent() {
    tracking.trackEvent({
        category: 'promo interaction',
        action: 'complete the look list displayed',
        label: 'complete the look',
    });
}

export function trackComplementaryGridToggleExpansionEvent(expanding = true, gridItems = null) {
    tracking.trackEvent({
        category: 'promo interaction',
        action: 'complete the look view button clicked',
        label: expanding ? 'view more' : 'view less',
    });

    if (expanding && gridItems) {
        trackComplementaryItemImpressions(gridItems);
    }
}

export function trackComplementaryItemClickEvent() {
    tracking.trackEvent({
        category: 'promo interaction',
        action: 'complete the look list clicked',
        label: 'complete the look',
    });
}

/**
 * @see PdpRespSellerItemsGrid.jsx
 */
const SELLER_ITEMS_LIST = 'pdp more from dealer';
export function trackSellerItemImpressions(gridSellerItems) {
    fireEcommerceImpressions(gridSellerItems, SELLER_ITEMS_LIST);
}

export function trackSellerItemClick(index, gridSellerItem) {
    fireEcommerceClick(index, gridSellerItem, SELLER_ITEMS_LIST);
}

export function trackSellerPageClick() {
    tracking.trackEvent({
        action: 'click to seller page',
        category: 'dealer click',
        label: 'PDP',
    });
}

export function trackItemsDisplayed({ moduleType = '', actionValue = '' } = {}) {
    const label = `related items${moduleType && ' - ' + moduleType}`;
    const action = `landing module displayed${actionValue && ' - ' + actionValue}`;
    tracking.trackEvent({
        action,
        label,
        category: LANDING_CATEGORY,
    });
}

export function trackViewMoreRelatedItemsClick() {
    tracking.trackEvent({
        action: 'YMAL view button clicked',
        category: 'promo interaction',
        label: 'view more',
    });
}

export function trackViewLessRelatedItemsClick() {
    tracking.trackEvent({
        action: 'YMAL view button clicked',
        category: 'promo interaction',
        label: 'view less',
    });
}

export function trackViewMoreVisuallySimilarClick() {
    tracking.trackEvent({
        action: 'view more clicked',
        category: 'product',
        label: VISUALLY_SIMILAR_ITEMS_LIST,
    });
}
export function trackCarouselEvent(direction) {
    tracking.trackEvent({
        label: direction,
        category: 'promo interaction',
        action: 'more from seller arrow clicked',
    });
}

export function trackCarouselItemImpression(trackingObj) {
    tracking.trackEcommerce({
        type: 'productImpression',
        actionField: {
            list: 'pdp more from dealer',
        },
        products: [
            {
                ...trackingObj,
                list: 'pdp more from dealer',
            },
        ],
    });
}
